import { createContext } from 'svelte'

type ProgressBarContext = {
  hoverTime: number
  isDragging: boolean
  isSmooth: boolean
  isLiveStream: boolean
  width: number
}

export const [getProgressBarContext, setProgressBarContext] =
  createContext<ProgressBarContext>()
